<template>
    <div>
        <h1 class="onboarding-title">You're going to love it{{ userName ? `, ${userName}` : '' }}</h1>
        <p class="onboarding-desc">You're about to experience the best proofing software for
            high velocity creative teams. Your free account is designed to make sure you get the
            best of everything from Ashore.</p>
        <div class="onboarding-card">
            <div class="onboarding-card-section">
                <h6 class="onboarding-card-heading">Your Free Account Includes:</h6>
                <ul class="feature-list">
                    <li v-for="(item, index) in featuresIncludes" :key="index">
                        <img src="/img/check.svg" width="16" alt="Check">
                        <span>{{ item }}</span>
                    </li>
                </ul>
            </div>

            <div class="onboarding-card-section">
                <h6 class="onboarding-card-heading">Upgrade to Unlock:</h6>
                <ul class="feature-list">
                    <li v-for="(item, index) in featuresCanUnlock" :key="index">
                        <img src="/img/x.svg" width="16" alt="X">
                        <span>{{ item }}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="onboarding-actions">
            <button @click="handleNextStep" class="auth-btn-primary">Got it!</button>
            <button @click="navigateToBilling" class="auth-btn-ghost">Upgrade Now</button>
        </div>
    </div>
</template>

<script>

import { ROUTES } from '../../utils/constants'

export default {
    name: "Screen1",
    props: {
        currentStep: {
            type: Number,
            required: true
        },
        handleNextStep: {
            type: Function,
            required: true
        },
        featuresCanUnlock: {
            type: Array,
            required: true
        },
        featuresIncludes: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            userName:  _.get(this, '$A.Auth.name', '')
        }
    },
    methods: {
        navigateToBilling() {
            this.$router.push(ROUTES.BILLING);
        }
    }
};
</script>
